import { z } from 'zod';
/**
 * SSO status response — returns SP-side credentials needed to configure an Okta
 * SAML app, plus current configuration state for the tenant.
 */
export const ssoStatusResponseSchema = z.object({
    tenantId: z.string(),
    projectId: z.string(),
    /** SP Entity ID — `projectId-tenantId`. Paste into Okta "Audience URI" field. */
    spEntityId: z.string(),
    /**
     * Full SP ACS URL including ssoId query param. Paste into Okta "Single sign on URL".
     * Empty string when SSO has never been configured for this tenant.
     */
    spACSUrl: z.string(),
    /** Descope SSO configuration ID — extracted from spACSUrl. Paste into OIN "Kirin SSO ID" variable. */
    ssoId: z.string(),
    /** Whether IdP metadata has been configured. */
    isConfigured: z.boolean(),
    /** Email domain(s) that trigger auto-routing to this SSO connection. */
    domains: z.array(z.string()),
    /** The IdP metadata URL that was last configured (if any). */
    idpMetadataUrl: z.string().optional(),
});
/**
 * Configure SSO request — submit the Okta Metadata URL and email domain.
 * Kirin calls the Descope Management API to configure the SAML connection.
 */
export const configureSSOBodySchema = z.object({
    /**
     * IdP SAML metadata URL — must be a well-formed URL (same rules as `z.string().url()`).
     * Example: `https://company.okta.com/app/<appId>/sso/saml/metadata`
     */
    metadataUrl: z.string().trim().url('Enter a valid URL.'),
    /**
     * Email domain for SSO auto-routing (e.g. `acme.com`).
     * Employees with this domain are automatically routed to this Okta.
     */
    domain: z
        .string()
        .min(1, 'Email domain is required')
        .regex(/^[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?(\.[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*\.[a-z]{2,}$/i, 'Enter a valid email domain only, e.g. company.com or mail.example.ai (no @ symbol, no https://, no path).'),
});
/**
 * Disconnect SSO response — empty response for successful disconnect
 */
export const disconnectSSOResponseSchema = z.object({
    success: z.boolean(),
});
//# sourceMappingURL=sso-settings.js.map